import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import styles from './index.module.scss'
import { ILocationBase } from '../../../types'

type Props = {
  name: string
  locations?: ILocationBase[]
}

export const LocationList: FC<Props> = ({ name, locations = [] }) => {
  const { t } = useTranslation(['companies-users-[id]'])

  return (
    <div className={styles.container}>
      <div className={styles.name}>
        {name}
        <span>&nbsp;</span>:
      </div>
      <div className={styles.locationValue}>
        {locations.length === 0 && <span>{t('未選択')}</span>}
        {locations.length > 0 &&
          locations.map((location) => {
            return (
              <span className={styles.locationTag} key={location.slug}>
                {location.name}
              </span>
            )
          })}
      </div>
    </div>
  )
}
